import React from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import {useUpdateAccountCultureMutation} from "../../stores/account/account.api";


import './Languanges.style.scss'
import {FormattedMessage} from "react-intl";

export default function Languages({onClose}) {
    const [updateAccountCulture, result] = useUpdateAccountCultureMutation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleChangeLanguage = (locale) => {
        updateAccountCulture(locale)
        if(onClose)
            onClose();
    }

    return (
        <div>
            <Button
                id="languageButton"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <span className="languageLabel"><FormattedMessage id={"navigationHeader.myAccount.language"}/></span>
                <MenuItem className="lg en" onClick={() => handleChangeLanguage('en-US')} />
                <MenuItem className="lg fr" onClick={() => handleChangeLanguage('fr-FR')} />
                <MenuItem className="lg es" onClick={() => handleChangeLanguage('es-MX')}/>
            </Button>
            {/*<Menu*/}
            {/*    id="languageMenu"*/}
            {/*    anchorEl={anchorEl}*/}
            {/*    open={open}*/}
            {/*    onClose={handleClose}*/}
            {/*    MenuListProps={{*/}
            {/*        'aria-labelledby': 'basic-button',*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <MenuItem onClick={() => handleChangeLanguage('en-US')}>ENGLISH</MenuItem>*/}
            {/*    <MenuItem onClick={() => handleChangeLanguage('fr-FR')}>FRENCH</MenuItem>*/}
            {/*    <MenuItem onClick={() => handleChangeLanguage('es-MX')}>SPANISH</MenuItem>*/}
            {/*</Menu>*/}
        </div>
    );
}
